import { gql } from '@apollo/client';

const CLASSROOM_STATS_FRAGMENT = gql`
  fragment BaseClassroomStats on ClassroomStats {
    studentCount
    userCount
  }
`;

export default CLASSROOM_STATS_FRAGMENT;
